import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { AppComponent } from './app.component';
import { DvlMainComponent } from './main/main.component';
import { DvlKitchenComponent } from './kitchen/kitchen.component';
import { DvlReceptionComponent } from './reception/reception.component';
import { DvlMonitorComponent } from './reception/monitor.component';
import { DvlInfoDialogComponent } from './info-dialog/info-dialog.component';
import { DvlFoodPickerComponent } from './reception/components/food-picker/food-picker.component';
import { DvlFoodConfirmComponent } from './reception/components/food-picker/components/food-confirm/food-confirm.component';
import { DvlDeleteConfirmComponent } from './reception/components/attendee-form/components/delete-confirm/delete-confirm.component';
import { DvlBraceletPickerComponent } from './reception/components/bracelet-picker/bracelet-picker.component';
import { DvlAttendeeFormComponent }         from './reception/components/attendee-form/attendee-form.component';
import { DvlAttendeeMonitorFormComponent }  from './reception/components/attendee-form/attendee-monitor-form.component';
import { DvlAlertsDialogComponent } from './kitchen/components/alerts-dialog/alerts-dialog.component';
import { Autosize } from 'angular2-autosize';

import { DvlSettingsService } from './services/settings.service';
import { DvlBirthdaysService } from './services/birthdays.service';
import { AuthService } from './services/auth.service';

import { DvlBraceletColorPipe } from './pipes/bracelet-color.pipe';
import { DvlFoodPipe } from './pipes/food.pipe';
import { DvlDessertPipe } from './pipes/dessert.pipe';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';

const firebaseConfig = {
  // apiKey: 'AIzaSyBvSnfjf-LG0BWRabG3ASL16Jz2QKYPYBk',
  // authDomain: 'diverland-test.firebaseapp.com',
  // databaseURL: 'https://diverland-test.firebaseio.com',
  // projectId: 'diverland-test',
  // storageBucket: 'diverland-test.appspot.com',
  // messagingSenderId: '275482099297'
  // apiKey: "AIzaSyC2BHYDDCssQMBF1zMawotXdVK7MV1c18A",
  // authDomain: "diverland-ankaa.firebaseapp.com",
  // databaseURL: "https://diverland-ankaa.firebaseio.com",
  // projectId: "diverland-ankaa",
  // storageBucket: "diverland-ankaa.appspot.com",
  // messagingSenderId: "862894739337"
  apiKey: "AIzaSyD0uwmqVacLCa0Leq6DUfz0Fuu8ITYh8ak",
  authDomain: "diverland-ankaa.firebaseapp.com",
  databaseURL: "https://meriendas-diverland.firebaseio.com/",
  projectId: "meriendas-diverland",
  storageBucket: "diverland-ankaa.appspot.com",
  messagingSenderId: "683131352026"
};

const appRoutes: Routes = [
  {
      path: '',
      component: DvlMainComponent
  },
  {
      path: 'cocina',
      component: DvlKitchenComponent
  },
  {
      path: 'recepcion',
      component: DvlReceptionComponent,
  },
  {
      path: 'monitor',
      component: DvlMonitorComponent,
  }
];

@NgModule({
  declarations: [
    AppComponent,
    DvlKitchenComponent,
    DvlReceptionComponent,
    DvlMonitorComponent,
    DvlMainComponent,
    DvlInfoDialogComponent,
    DvlFoodPickerComponent,
    DvlFoodConfirmComponent,
    DvlDeleteConfirmComponent,
    DvlAttendeeFormComponent,
    DvlAttendeeMonitorFormComponent,
    DvlAlertsDialogComponent,
    DvlBraceletColorPipe,
    DvlBraceletPickerComponent,
    DvlFoodPipe,
    DvlDessertPipe,
    Autosize
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule
  ],
  providers: [
    AngularFireDatabase,
    DvlSettingsService,
    DvlBirthdaysService,
    AuthService,
    DvlBraceletColorPipe,
    DvlFoodPipe,
    DvlDessertPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/app.module.ts